export default __webpack_public_path__ + "static/media/BatteryMaintenance2.f2e7105c.png";